import React, { useState } from 'react';
import { CampaignModel, GroupChatModel } from '../../models/conversations';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { FormHelperText, Tooltip } from "@mui/material";
import ButtonComponent from '../shared/button/button.component';
import { ToasterTexts, buttonLabels } from '../shared/constants';
import { validateForm } from '../shared/form-validation';
import { CancelIcon } from '../../icon';
import { ContactService } from '../../services/ContactService';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import { AppState } from '../../reducers/models';
import { HandlePushCampaignChatName,} from '../../actions';
import { Dispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

interface Props{
    onClose: (x: boolean) => void;
    show: boolean;
    Groupchat: GroupChatModel;
    Campaign?: CampaignModel;
}

type Errors = {
    GroupChatName?: string;
    name?: string;
};

type State = {
    name: string;
    isLoading: boolean;
    errors: Errors;
};

const GroupChatView = (props: Props) => {
    const dispatch = useDispatch()
    const [state, setState] = useState<State>({
        name: !!props.Campaign && !!props.Campaign.ID ? !!props.Campaign.Name ? props.Campaign.Name : "" : !!props.Groupchat.Name ? props.Groupchat.Name : "",
        isLoading: false,
        errors: {
            name: "",
        },
    })

    const handleChange = (name: string, value: string) => {
        let newErrors = { ...state.errors };
        if (value.trim().length === 0) {
            newErrors.GroupChatName = name === 'GroupChatName' ? "Group chat name cannot be empty" : "Campaign name cannot be empty";
        } else if (!!props.Campaign ? value.length > 30 : value.length > 75) {
            newErrors.GroupChatName = name === 'GroupChatName' ? `Group chat name cannot exceed ${props.Campaign ? "30" : "75"} characters` : `Campaign name cannot exceed ${props.Campaign ? "30" : "75"} characters`;
        } else {
            newErrors.GroupChatName = "";
        }
        setState((prevState) => ({
            ...prevState,
            errors: newErrors,
            name: value,
        }));
    };

    const formSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validateForm({ [!!props.Campaign && props.Campaign.ID ? "newgroupname" : "groupchatname"]: state.name }, (newErrors) => {
            setState((prevState) => ({
                ...prevState,
                errors: {
                    ...prevState.errors,
                    ...newErrors,
                },
            }));
        })) {
            const data = {
                Id: !!props.Campaign && props.Campaign.ID ? props.Campaign.ID : props.Groupchat.ID,
                name: state.name
            }
            setState((prevstate) => ({
                ...prevstate, isLoading: true
            }))
            if (!!props.Campaign && !!props.Campaign.ID) {
                ContactService.editCampaginName(data)
                    .then(response => {
                        setState((prevstate) => ({
                            ...prevstate, isLoading: false
                        }))
                        HandlePushCampaignChatName(dispatch,data.Id, data.name)
                        setToast(ToasterTexts.EDIT_CAMPAIGN_NAME_SUCCESS, ToasterType.SUCCESS)
                        props.onClose(false)
                    }).catch(err => {
                        setState((prevstate) => ({
                            ...prevstate, isLoading: false
                        }))
                        setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
                        props.onClose(false)
                    })
            } else {
                ContactService.editGroupchatName(data)
                    .then(response => {
                        
                        setState((prevstate) => ({
                            ...prevstate, isLoading: false
                        }))
                     setToast(ToasterTexts.EDIT_GROUPCHAT_NAME_SUCCESS, ToasterType.SUCCESS)
                        props.onClose(false)
                    }).catch(err => {
                        setState((prevstate) => ({
                            ...prevstate, isLoading: false
                        }))
                        setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
                        props.onClose(false)
                    })
            }
        }
    }

    const closehandler = () => {
        props.onClose(true)
    }

    return (
        <Dialog
            maxWidth="sm"
            fullWidth={true}
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
            open={props.show}
            onClose={() => props.onClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper: "w-50 br-2 dialogue-shadow" }}
            disableEscapeKeyDown
        >
            <DialogTitle id="alert-dialog-title" className="dialog-header">
                <div className='d-flex'>
                    <span className={"h2-regular color-text-field-font"}>{!!props.Campaign ? !props.Campaign.Name ? "Add Campaign Name" : "Edit Campaign Name" : !!props.Groupchat.Name ? "Edit Group Chat Name" : "Add Group Chat Name"}</span>
                    <Tooltip title="Close" placement="bottom">
                        <span className="ml-auto mr-1">
                            <CancelIcon
                                className={"c-pointer"}
                                onClick={() => props.onClose(false)}
                            />
                        </span>
                    </Tooltip>
                </div>
            </DialogTitle>
            <DialogContent className=" p-2  o-x-hidden">
                <form
                    noValidate
                    autoComplete="off"
                    onSubmit={formSubmit}
                    className="m-auto"
                >
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                autoFocus
                                name={!!props.Campaign?.ID ? "CampaignName" : "GroupChatName"}
                                placeholder={!!props.Campaign?.ID ? "Campaign Name" : "Group Name"}
                                label={!!props.Campaign?.ID ? "Campaign Name" : "Group Name"}
                                variant="outlined"
                                size="small"
                                required
                                fullWidth
                                value={state.name}
                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                autoComplete='no'
                            />
                            <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                {state.errors.GroupChatName}
                            </FormHelperText>
                        </Grid>
                    </Grid>
                    <div className="d-flex float-right my-2">
                        <ButtonComponent OnClick={closehandler} ButtonLabel={buttonLabels.CANCEL} ClassName={"mr-1"} Variant={"secondary-btn-small"} />
                        <ButtonComponent Type={"submit"} ButtonLabel={buttonLabels.SAVE} Loading={state.isLoading} ClassName={"px-4"} Variant={"primary-btn-small"} />
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default GroupChatView;
